import {
    SET_CENTRO_DIA, DESBLOQUEAR_CIERRE_DIARIO, CIERRE_DIARIO_CERRAR_DIA, DESBLOQUEAR_CIERRE_SEMANAL,
    CIERRE_SEMANAL_CERRAR_SEMANA, INVALIDATE_CENTRO_DIA, ENABLE_CENTRO_DIA
} from '../constants/action_types';

const initialState = { centro: {}, dia: '', isDiaCerrado: false, isSemanaCerrada: false, existeCierreSemanal: false, isLoaded: false, isValid: false };

export default function (state = initialState, action) {
    switch (action.type) {
        case SET_CENTRO_DIA:

            return {
                ...state,
                isLoaded: !action.meta.fromUI,
            };
        case SET_CENTRO_DIA + '_SUCCESS':

            // return {
            //     centro: action.meta.centro,
            //     dia: action.meta.dia,
            //     isDiaCerrado: action.payload.data.isDiaCerrado,
            //     isSemanaCerrada: action.payload.data.isSemanaCerrada,
            //     existeCierreSemanal: action.payload.data.existeCierreSemanal,
            //     isLoaded: true,
            //     isValid: true
            // };

            let dt = new Date(action.payload.data.fecha.slice(0, 10));


            return {
                centro: action.payload.data.centro,
                dia: dt.toISOString().slice(0, 10),
                isDiaCerrado: action.payload.data.isDiaCerrado,
                isSemanaCerrada: action.payload.data.isSemanaCerrada,
                existeCierreSemanal: action.payload.data.existeCierreSemanal,
                isLoaded: true,
                isValid: true
            };


        // case GET_CIERRE_SEMANAL_DATOS + "_SUCCESS":
        //     return {...state, isSemanaCerrada: action.payload.data.isSemanaCerrada}


        // case SET_INITIAL_CENTRO_DIA + '_SUCCESS':

        //     let dt = new Date(action.payload.data.ultimoCierreDiario.slice(0, 10));

        //     // if(action.meta.semanal){
        //     //     let offset = action.payload.data.centro.iDiaCierre - dt.getDay();
        //     //     if(offset < 0) offset += 7;
        //     //     dt.setDate(dt.getDate() + offset);
        //     // }

        //     return {
        //         centro: action.payload.data.centro,
        //         dia: dt.toISOString().slice(0, 10),
        //         isDiaCerrado: false,
        //         isSemanaCerrada: false,
        //         existeCierreSemanal: true,
        //         isLoaded: true,
        //         isValid: true
        //     };
        case INVALIDATE_CENTRO_DIA:

            return { ...state, isValid: false }

        case ENABLE_CENTRO_DIA:
            return { ...state, isValid: true }

        case DESBLOQUEAR_CIERRE_DIARIO + "_SUCCESS":

            return { ...state, isDiaCerrado: false }

        case CIERRE_DIARIO_CERRAR_DIA + "_SUCCESS":

            return { ...state, isDiaCerrado: true }

        case DESBLOQUEAR_CIERRE_SEMANAL + "_SUCCESS":

            return { ...state, isSemanaCerrada: false }

        case CIERRE_SEMANAL_CERRAR_SEMANA + "_SUCCESS":

            return { ...state, isSemanaCerrada: true }

        default:
            return state;
    }
}
